import { Card } from "@tokenterminal/core/ui/layout/card/Card"
import { EmptyState } from "@tokenterminal/core/ui/messaging/emptyState/EmptyState"
import { DEFAULT_TAG } from "pages/discover"

type DashboardEmptyStateProps = {
  tag: string
  search: string
}

export const DashboardEmptyState = ({
  tag,
  search,
}: DashboardEmptyStateProps) => {
  return (
    <Card className="bg-transparent rounded-xl w-full min-h-[400px] flex justify-center items-center">
      <EmptyState
        headingText={
          tag !== DEFAULT_TAG && search === ""
            ? `The category "${tag}" didn't return any results.`
            : `Your search for "${search}" didn't return any results.`
        }
        bodyText={
          tag !== DEFAULT_TAG && search === ""
            ? "Try different filters or add more data to see results"
            : "Try a different search"
        }
      />
    </Card>
  )
}
